import { PaxCost } from './pax-cost';

export class ItemCostPortion {
    primaryJobCost: PaxCost;
    secondaryJobCost: PaxCost;
    totalCost: number;
    estimatedCost: number;
    currency: string;
}
